module.exports = __webpack_public_path__ + "img/pinjia6.aae522ae.jpg";